import { getIsLoggedIn, getLangOptions } from 'actions/auth/login';
import LanguageToggleDiv from './LanguageToggleComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getClientCode } from 'actions/ui/init/initSelectors';
import { getLocale } from 'actions/language/selectors';
import { getPathname } from 'actions/routes/routeSelectors';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => ({
  isLoggedIn: getIsLoggedIn(state),
  langOptions: getLangOptions(state),
  lang: getLocale(state),
  clientCode: getClientCode(state),
  pathname: getPathname(state)
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

// Create higher-order component which feeds in specified props.
const LanguageToggleContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LanguageToggleDiv);

export default LanguageToggleContainer;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/LanguageToggle/LanguageToggleContainer.js